import CollectionManager from './CollectionManager';

export default CollectionManager;
